import * as React from 'react';

import { DeviceAverageDischargeSettings } from './deviceAverageDischargeSettings';
import { WorldSettings } from 'services/config/config';

import '../settings.css';

export interface IProps {
  worldSettings: WorldSettings,
  onDataChanged: (data: WorldSettings) => void,
  submitInProgress: boolean,
  dataTimestamp: number
}

export function DeviceAlertsSettings(props: IProps) {
  return (<div className="threshold-settings-composition deviceAlerts">
    <DeviceAverageDischargeSettings
      timeStamp={props.dataTimestamp}
      onDataChanged={props.onDataChanged}
      worldSettings={props.worldSettings}
      submitInProgress={props.submitInProgress}
    />
  </div>);
}
